/**
 * Detect supplier quote PDF format from extracted text.
 * ENCO is checked before Rhenium to avoid misclassification.
 */

import { isEncoQuote, ENCO_PARSER_FORMAT_ID } from './parsers/encoQuoteParser';
import {
  isRheniumQuote,
  RHENIUM_PARSER_FORMAT_ID,
} from './parsers/rheniumQuoteParser';

/** @typedef {'enco_scientific_quote_pdf' | 'rhenium_quote_pdf' | 'unknown_pdf'} SupplierFormatId */

/**
 * @param {string} text
 * @returns {SupplierFormatId}
 */
export function detectSupplierFormat(text) {
  if (isEncoQuote(text)) {
    return ENCO_PARSER_FORMAT_ID;
  }

  if (isRheniumQuote(text)) {
    return RHENIUM_PARSER_FORMAT_ID;
  }

  return 'unknown_pdf';
}
